import { gql } from '@apollo/client';

export const SET_USER_NOTIFICATION_SETTING = gql`
  mutation SetUserNotificationSetting(
    $input: SetUserNotificationSettingInput!
  ) {
    setUserNotificationSetting(input: $input)
  }
`;
